import axios from "axios";
import {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function EditSubCat() {
    const {subcat_id} = useParams();
    const [cats, setCats] = useState([]);
    const [subCatData, setsubCatData] = useState({
        "cat": '',
        "subcat": '',
        "amount": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        try {
            axios.get(baseUrl + 'edit-subcat/' + subcat_id)
                .then(function (response) {
                    setsubCatData({
                        cat_id: response.data.cat.id,
                        subcat: response.data.subcat,
                        amount: response.data.amount,
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handleChange = (event) => {
        setsubCatData({
            ...subCatData,
            [event.target.name]: event.target.value
        });
    }
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('cat', subCatData.cat_id);
        _formData.append('subcat', subCatData.subcat);
        _formData.append('amount', subCatData.amount);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.put(baseUrl + 'edit-subcat/' + subcat_id, _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200) {
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    setTimeout(() => {
                        window.location.href = ('/add-subcat/');
                    }, 2000);
                });
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        try {
            axios.get(baseUrl + 'cat/')
                .then(function (response) {
                    setCats(response.data);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Edit Category</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="cat_id" className="form-label">Category</label>
                                    <select name="cat_id" value={subCatData.cat_id} onChange={handleChange}
                                            className="form-control">
                                        {cats.map((category, index) => {
                                            return <option key={index} value={category.id}>{category.category}
                                            </option>
                                        })}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="category" className="form-label">Sub Category</label>
                                    <input type="text" className="form-control" name="subcat" value={subCatData.subcat}
                                           onChange={handleChange} id="subcat"/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="amount" className="form-label">Amount</label>
                                    <input type="number" className="form-control" name="amount"
                                           value={subCatData.amount}
                                           onChange={handleChange} id="amount"/>
                                </div>

                                <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default EditSubCat;